import React from 'react';
import { Dropdown } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import useGlobal from '../../../../store';
import TimbradoSftpStatus from '../../enum/TimbradoSftpStatus';
import CustomDropdownToggle from '../../../../facturotopia/CustomDropdownToggle';

const mapState = (store) => {
  return store.modulo.timbrado_sftp.list;
};

const mapActions = (actions) => {
  return { ...actions.modulo.timbrado_sftp.list };
};

const FilterButtonType = (props) => {
  const { variant = 'secondary', status, text, icon } = props;

  return (
    <Dropdown.Item
      variant={variant}
      eventKey={status}
    >
      {!!icon && <FontAwesomeIcon icon={icon} />}
      {text ? ` ${text}` : ''}
    </Dropdown.Item>
  );
};

const TimbradoSftpFilterByStatus = (props) => {
  const [state, actions] = useGlobal(mapState, mapActions);

  const { status } = state.filters;

  const handleOnSelect = (status) => {
    actions.paginate({
      page: 1,
      status,
    });
  };

  let title = 'Status';

  if (status !== '' && status !== undefined) {
    title = TimbradoSftpStatus.search(status).getName();
  }

  return (
    <>
      <Dropdown
        title={title}
        id="timbrado-sftp-by-status"
        className="float-left mr-1"
        onSelect={handleOnSelect}
      >
        <Dropdown.Toggle as={CustomDropdownToggle}>{title}</Dropdown.Toggle>

        <Dropdown.Menu>
          <FilterButtonType
            text="Todos"
            current={status}
            status=""
          />

          <FilterButtonType
            text="Pending"
            current={status}
            status="0"
          />

          <FilterButtonType
            text="Cancelled"
            current={status}
            status="-1"
          />

          <FilterButtonType
            text="Error"
            current={status}
            status="-2"
          />

          <FilterButtonType
            text="Failed"
            current={status}
            status="-3"
          />

          <FilterButtonType
            text="Success"
            current={status}
            status="1"
          />

          <FilterButtonType
            text="Queued"
            current={status}
            status="2"
          />

          <FilterButtonType
            text="Duplicate"
            current={status}
            status="3"
          />
        </Dropdown.Menu>
      </Dropdown>
    </>
  );
};

export default TimbradoSftpFilterByStatus;
